export default "__VITE_ASSET__CzDsCb7d__"